<template>
  <Message class="cr-message rygen-message p-message-unique">
    <template #icon>
      <img src="@/assets/img/customerRouted.svg" alt="" class="cr-icon" />
    </template>

    <template #default>
      {{ text }}
      <span
        v-tooltip.top="t('customerRouted.customerRoutedMoreInfo')"
        class="whats-this-link cursor-pointer underline"
      >
        {{ t('common.whatsThis') }}
      </span>
    </template>
  </Message>
</template>

<script lang="ts" setup>
import { usePrimeVue } from 'primevue/config';
import { toRefs } from 'vue';
import { useI18n } from 'vue-i18n';

import { useTooltip } from '@rygen/rygen-ui/composables';

import i18n from '@/i18n';

import Message from 'primevue/message';

const props = defineProps({
  text: {
    type: String,
    default: () => i18n.global.t('customerRouted.customerRoutedShipmentInfo'),
  },
});
const { text } = toRefs(props);
const { t } = useI18n();
const vTooltip = useTooltip();

defineExpose({
  $primevue: usePrimeVue(),
});
</script>

<style>
.cr-message.p-message {
  --p-message-content-gap: 0;

  .p-message-content {
    padding: 0;

    .cr-icon {
      padding: var(--p-message-content-padding);
      border-right: 1px solid var(--p-fuchsia-100);
    }

    .p-message-text {
      padding: var(--p-message-content-padding);

      .whats-this-link {
        color: var(--p-primary-color);
        margin-left: var(--sp-1);
      }
    }
  }
}
</style>
